var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showTimeAxis)?_c('timeAxis',{attrs:{"marks":_vm.marks,"max":190,"flightData":_vm.flightData},on:{"keyFn":_vm.keyFrameFn,"playpause":_vm.playpause,"redo":_vm.redo,"watchValue":_vm.watchValue}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }